import React, { Fragment, useState, useEffect } from "react";
import {
  Card,
  FormGroup,
  Label,
  Input,
  Form,
  FormFeedback,
  Button,
  Row,
  Col,
  Container,
} from "reactstrap";
import {

  SINGLE_DOG_DETAILS_URL,
  UPLOAD_FILE,
  USER_CHOOSE_PLAN,
} from "../../../constants/ApiPaths";
import API from "../../../redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import {
  END_USER_DETAILS_SUCCESS,
} from "../../../redux/actions/ActionTypes";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";

import YupSchemaCreator from "../../Agency/Template/YupSchemaCreator";
import * as Yup from "yup";
import {
  customerName,
  customerState,
} from "../../../functions/CoreFunctions";

export const InputField = (props) => {
  console.log("props text");
  const {
    handlechange,
    values = {},

    formik,
    errors = {},
  } = props;
  const {
    uniqueId,
    placeholder = "",
    label = "",
    isMandatory = "",
  } = props.data || {};
  const { handleBlur } = formik;
  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>
          {isMandatory === true ? `${label} *` : label}
        </Label>
        <Input
          onChange={handlechange}
          value={values[uniqueId]}
          type="text"
          name={uniqueId}
          id={uniqueId}
          onBlur={handleBlur}
          invalid={errors[uniqueId]}
          placeholder={placeholder}
        />
        <FormFeedback>
          {errors[uniqueId] && <div>{errors[uniqueId]}</div>}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const TextAreaField = (props) => {
  const { handlechange, values = {}, formik, errors = {} } = props;
  const {
    uniqueId,
    placeholder = "",
    label = "",
    isMandatory = "",
  } = props.data || {};
  const { handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>
          {isMandatory === true ? `${label} *` : label}
        </Label>

        <Input
          value={values[uniqueId]}
          onChange={handlechange}
          type="textarea"
          name={uniqueId}
          id={uniqueId}
          onBlur={handleBlur}
          invalid={errors[uniqueId]}
          placeholder={placeholder}
        />
        <FormFeedback>
          {errors[uniqueId] && <div>{errors[uniqueId]}</div>}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};
export const FileUploadField = (props) => {
  const { values = {}, formik, answers } = props;
  const {
    licenseRequiredDocId,
    documentName = "",
    documentDescription = "",
    isMandatory = false,
  } = props.data || {};
  // const [fileName, setFileName] = useState();
  console.log("is", isMandatory);
  let handleFileUpload = async (e) => {
    e.preventDefault();
    // setpageloading(true);
    const selectedFile = e.target.files[0];
    console.log(selectedFile);
    // setFileName(selectedFile.name);

    if (selectedFile) {
      const formDat = new FormData();
      formDat.append("file", selectedFile);
      const config = {
        method: "POST",
        url: UPLOAD_FILE,
        data: formDat,
        // headers: authCustomerHeader(),
      };
      try {
        const response = await API(config);
        const { status, filePath } = response.data;
        if (status === "Success") {
          formik.setFieldValue(licenseRequiredDocId, filePath);
        }
      } catch (error) {
        console.error(error);
      } finally {
        // setpageloading(false);
      }
    }
  };
  return (
    <Col md={4} key={licenseRequiredDocId}>
      <FormGroup>
        <Label for={licenseRequiredDocId}>
          {isMandatory === true ? `${documentName} *` : documentName}
        </Label>

        <Input
          value={values[licenseRequiredDocId]}
          onChange={handleFileUpload}
          type="file"
          required={isMandatory}
          name={licenseRequiredDocId}
          id={licenseRequiredDocId}
          placeholder={documentDescription}
        />
      </FormGroup>
      {/* <a
        href={answers[licenseRequiredDocId]}
        target="_blank"
        rel="noopener noreferrer"
      >
        {answers[licenseRequiredDocId] ? "Uploaded file" : ""}
      </a> */}
    </Col>
  );
};

export const DateField = (props) => {
  const { handlechange, values = {}, formik, errors = {} } = props;
  const { uniqueId, label = "", isMandatory = "" } = props.data || {};
  const { handleBlur } = formik;
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  today = yyyy + "-" + mm + "-" + dd;
  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>
          {isMandatory === true ? `${label} *` : label}
        </Label>
        <Input
          type="date"
          value={values[uniqueId]}
          onChange={handlechange}
          name={uniqueId}
          id={uniqueId}
          onBlur={handleBlur}
          min={today}
          invalid={errors[uniqueId]}
        />
        <FormFeedback>
          {errors[uniqueId] && <div>{errors[uniqueId]}</div>}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const TimeField = (props) => {
  const { handlechange, values = {}, formik, errors = {} } = props;

  const { uniqueId, label = "", isMandatory = "" } = props.data || {};
  const { handleBlur } = formik;
  console.log(values, "time");
  const tempChange = (e) => {
    console.log(e);
    console.log(e?.value);
    handlechange(e);
  };
  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>
          {isMandatory === true ? `${label} *` : label}
        </Label>
        <Input
          type="time"
          onBlur={handleBlur}
          invalid={errors[uniqueId]}
          value={values[uniqueId]}
          onChange={tempChange}
          name={uniqueId}
          id={uniqueId}
        />
        <FormFeedback>
          {errors[uniqueId] && <div>{errors[uniqueId]}</div>}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const SelectField = (props) => {
  const { handlechange, values = {}, formik, errors = {} } = props;
  const {
    type,
    uniqueId,
    placeholder = "",
    options = [],
    label = "",
    isMandatory = "",
  } = props.data || {};
  const { handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>
          {isMandatory === true ? `${label} *` : label}
        </Label>
        <Input
          type={type}
          onChange={handlechange}
          value={values[uniqueId]}
          id={uniqueId}
          name={uniqueId}
          onBlur={handleBlur}
          invalid={errors[uniqueId]}
          placeholder={placeholder}
        >
          <option>Please Select</option>
          {options.map((o) => (
            <option value={o.value} key={o.value}>
              {o.value}
            </option>
          ))}
        </Input>
        <FormFeedback>
          {errors[uniqueId] && <div>{errors[uniqueId]}</div>}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const CheckboxField = (props) => {
  const { handlechange, formik, errors = {} } = props;
  const {
    uniqueId,
    options = [],
    label = "",
    isMandatory = "",
  } = props.data || {};
  const { handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>
          {isMandatory === true ? `${label} *` : label}
        </Label>
        {options.map((o) => (
          <Col key={o.optionUniqueId} sm={10}>
            <FormGroup check>
              <Label check>
                <Input
                  onChange={handlechange}
                  value={o.value}
                  onBlur={handleBlur}
                  type="checkbox"
                  name={uniqueId}
                />{" "}
                {o.value} &nbsp;
              </Label>
            </FormGroup>
          </Col>
        ))}
        {errors[uniqueId] && (
          <div>
            <small style={{ color: "#dc3545" }}>Required</small>
          </div>
        )}
      </FormGroup>
    </Col>
  );
};

export const RadioField = (props) => {
  const { handlechange, formik, errors = {} } = props;
  const {
    uniqueId,
    options = [],
    label = "",
    isMandatory = "",
  } = props.data || {};
  const { handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>
          {isMandatory === true ? `${label} *` : label}
        </Label>
        {options.map((o) => (
          <Col key={o.optionUniqueId} sm={10}>
            <FormGroup check>
              <Label check>
                <Input
                  onBlur={handleBlur}
                  onChange={handlechange}
                  type="radio"
                  key={o.optionUniqueId}
                  value={o.value}
                  name={uniqueId}
                />{" "}
                {o.value} &nbsp;
              </Label>
            </FormGroup>
          </Col>
        ))}
        {errors[uniqueId] && (
          <div>
            <small style={{ color: "#dc3545" }}>Required</small>
          </div>
        )}
      </FormGroup>
    </Col>
  );
};

export const DynamicField = (props) => {
  const fieldTypes = {
    text: InputField,
    textarea: TextAreaField,
    date: DateField,
    select: SelectField,
    radio: RadioField,
    time: TimeField,
    checkbox: CheckboxField,
  };
  console.log(props, "props");
  const {
    data,
    handlechange,
    singledog,
    previewMode,
    values,
    formik,
    errors = {},
  } = props;
  console.log(data, "data");
  const Field = fieldTypes[props?.data?.type] || InputField;
  return (
    <Field
      data={data}
      handlechange={handlechange}
      singledog={singledog}
      formik={formik}
      values={values}
      previewMode={previewMode}
      errors={errors}
    />
  );
};

export const BackButton = (props) => {
  const { handlePress = () => {} } = props;
  return (
    <div className="top-btn">
      <Button onClick={handlePress} color="primary">
        {" "}
        <svg
          className="mr-3"
          xmlns="http://www.w3.org/2000/svg"
          width="10.977"
          height="7.321"
          viewBox="0 0 10.977 7.321"
        >
          <path
            id="Icon_ionic-ios-arrow-round-back"
            data-name="Icon ionic-ios-arrow-round-back"
            d="M11.859,11.392a.5.5,0,0,1,0,.7L9.548,14.415h8.819a.5.5,0,0,1,0,.991H9.548l2.318,2.322a.5.5,0,0,1,0,.7.494.494,0,0,1-.7,0L8.023,15.262h0a.557.557,0,0,1-.1-.156.473.473,0,0,1-.038-.191.5.5,0,0,1,.141-.347L11.165,11.4A.486.486,0,0,1,11.859,11.392Z"
            transform="translate(-7.882 -11.252)"
            fill="#fff"
          />
        </svg>
        Back
      </Button>
    </div>
  );
};

const Chooseplan = (props) => {
  const {
    licensePlanId,
    dogId,
    // singledog = [],
   
    pageloading,
    setpageloading,
    // answers,
    // setAnswers,
    validationSchema,
    setValidationSchema,
    errors,
    formik,
    showErrors
  } = props;
  console.log(licensePlanId, "pid");
  const [singledog, setSingleDog] = useState([]);
  const [answers, setAnswers] = useState({});

  // let { DogId } = useParams();
  // const [answers, setAnswers] = useState({});
  // const [validationSchema, setValidationSchema] = useState({});
  const [loading, setLoading] = useState(false);
  let previewMode = false;
  const dispatch = useDispatch();
  // const singledog = dog.filter((i) => i.dogId == DogId)[0] || {};
  // const [pageloading, setpageloading] = useState(false);

  const {
    licenseRequiredDocDetails = [],
    categoryDetails = [],
  } = useSelector((state) => state.CustomerFormReducer);
  const data = useSelector((state) => state.DogPlanDetailsReducer);
  console.log("plan", data);
  
  const getDogDetails = async () => {
    //  setDetailLoad(true);
    const config = {
      method: "GET",
      url: SINGLE_DOG_DETAILS_URL,
      //  headers: authHeader(),
      params: {
        dogId: dogId,
      },
    };
    try {
      const response = await API(config);
      const { data } = response.data;
      console.log("sinf", data);
      setSingleDog(data);
      // dogLicenseDetails(dogId);
      //  const { dogName, breed, color, DOB, sex, dogImageUrl, dogDescription } =
      //  data;
      //  setFormData({
      //    ...formData,
      //    dogName: dogName,
      //    breed: breed,
      //    color: color,
      //    DOB: DOB,
      //    sex: sex,
      //    dogImageUrl: dogImageUrl,
      //    dogDescription: dogDescription,
      //  });
    } catch (error) {
      console.error(error);
    } finally {
      //  setDetailLoad(false);
    }
  };
  useEffect(() => {
    if (dogId) {
      getDogDetails();
    }
  }, [dogId]);
  // const formik = useFormik({
  //   enableReinitialize: true,
  //   initialValues: answers,
  //   validationSchema: validationSchema,
  //   onSubmit: handleFormSubmit,
  // });

  const {
    handleSubmit,
    handleChange,
    values = {},
  
  } = formik;

  

  const fetchStateForm = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: USER_CHOOSE_PLAN,
      // headers: authCustomerHeader(),
      params: {
        licensePlanId: licensePlanId,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        const { licensePlanData } = response.data;
        dispatch({
          type: END_USER_DETAILS_SUCCESS,
          payload: licensePlanData,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (licensePlanId) fetchStateForm();
  }, [licensePlanId]);
  console.log("valid", validationSchema);
  useEffect(() => {
    let questions = [];
    categoryDetails.forEach((e) => {
      questions.push(...e.categoryPlaceHolder);
    });

    console.log(questions, "questions");

    questions = questions.filter((e) => e.isMandatory);
    questions = questions.map((question) => {
      if (question.type === "checkbox") {
        console.log("question", question);

        question.validationType = "array";
        question.validations = [
          {
            type: "min",
            params: [1], // at least one checkbox should be selected
          },
        ];
      }
      return question;
    });
    const yupSchema = questions.reduce(YupSchemaCreator, {});
    const schema = Yup.object().shape(yupSchema);

    setValidationSchema(schema);
  }, [answers]);

  useEffect(() => {
    let answers = {};

    const specialfunction = {
      PET_VALUE: singledog.dogName,
      USER_NAME: customerName(),
      PET_BREED: singledog.breed,
      CUSTOMER_STATE: customerState(),
      PET_COLOR: singledog.color,
    };
    if (data.categoryDetails) {
      const { categoryDetails = {} } = data;
      // licenseRequiredDocDetails.forEach((e) => {
      //   answers[e.licenseRequiredDocId] =
      //     categoryDetails[e.licenseRequiredDocId];
      // });

      setAnswers(categoryDetails);
      console.log("redux c", answers);
    } else {
      console.log("redux else part");

      categoryDetails.forEach(({ categoryPlaceHolder = [] }) => {
        categoryPlaceHolder.forEach(({ uniqueId, type, specialvalue }) => {
          if (!uniqueId) return;
          if (specialvalue) {
            console.log("splfun", specialfunction[specialvalue], singledog);
            answers[uniqueId] = specialfunction[specialvalue];
          } else {
            answers[uniqueId] = type === "checkbox" ? [] : "";
          }
        });
      });
      licenseRequiredDocDetails.forEach((e) => {
        answers[e.licenseRequiredDocId] = "";
      });
      console.log("answers", answers);
      console.log("cdetails", categoryDetails);
      setAnswers(answers);
    }
  }, [categoryDetails, licenseRequiredDocDetails, singledog]);

  if (loading) {
    return <CustomPageLoading />;
  }

  return (
    <div>
      {/* <HeaderLogo /> */}
      {pageloading && <CustomPageLoading />}

      <Container style={{ paddingBottom: "30px" }}>
        {/* <div className="page-title"> */}
        {/* <h4>{planName}</h4> */}
        {/* <BackButton handlePress={back} /> */}
        {/* </div> */}
        <Card body className="" style={{ minHeight: "50px" }}>
          <Form form="true" id="endUserLicenseForm" onSubmit={handleSubmit}>
            {categoryDetails.map((e) => {
              let categoryDocs = licenseRequiredDocDetails.filter(
                (doc) => doc.categoryid === e.categoryId
              );
              return (
                <Fragment key={e.categoryId}>
                  <div className="category-title-cp">
                    <h4>{e.categoryName}</h4>
                  </div>
                  <div>
                    <Row>
                      {e.categoryPlaceHolder.map((field) => {
                        return (
                          <Fragment key={field.uniqueId}>
                            <DynamicField
                              handlechange={handleChange}
                              formik={formik}
                              singledog={singledog}
                              values={values}
                              previewMode={previewMode}
                              data={field}
                              errors={errors}
                            />
                          </Fragment>
                        );
                      })}
                    </Row>
                    {!!categoryDocs.length && (
                      <>
                        <div className="category-documents">
                          <h6>Additional Documents</h6>
                        </div>
                        <Row>
                          {categoryDocs.map((doc) => (
                            <Fragment>
                              <FileUploadField
                                setpageloading={setpageloading}
                                data={doc}
                                formik={formik}
                                answers={answers}
                                showErrors={showErrors}
                              />
                            </Fragment>
                          ))}
                            {showErrors && (
                            <div style={{ color: "red", fontSize: "14px" }}>
                            Please upload all mandatory documents before proceeding.
                            </div>
                          )}
                        </Row>
                      </>
                    )}
                  </div>
                </Fragment>
              );
            })}
          </Form>
          <div>
            {/* <Button
              disabled={Delete}
              form="endUserLicenseForm"
              type="submit"
              color="primary"
              style={{ width: "-webkit-fill-available" }}
            >
              Submit
            </Button> */}
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default Chooseplan;
